import { getEventColor, getEventLabel } from "@/lib/api";

interface EventTypeBadgeProps {
	eventType: string;
	size?: "sm" | "xs";
	className?: string;
}

export function EventTypeBadge({
	eventType,
	size = "sm",
	className,
}: EventTypeBadgeProps) {
	const color = getEventColor(eventType);
	const label = getEventLabel(eventType);
	const sizeClasses =
		size === "xs"
			? "px-2 py-0.5 text-[10px]"
			: "px-2 py-1 text-xs";

	return (
		<div
			className={`inline-block rounded font-semibold uppercase tracking-wide text-white ${sizeClasses} ${className ?? ""}`}
			style={{ backgroundColor: color }}
		>
			{label}
		</div>
	);
}
